import { initializeApp } from "firebase/app";
import {
  Auth,
  GoogleAuthProvider,
  User,
  getAuth,
  onAuthStateChanged,
  signInWithPopup,
  signOut
} from "firebase/auth";

class FirebaseService {
  private _auth: Auth;
  constructor() {
    const firebaseConfig = {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyC0siHZqs9-7gkGgrnjM2y_ALYKbHZBhVw",
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "garther-develop.firebaseapp.com",
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "garther-develop",
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "garther-develop.firebasestorage.app",
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "519747682916",
      appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:519747682916:web:584d24087e954607099571",
      measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-YVKG5GG4NW"
    };
    const app = initializeApp(firebaseConfig);
    const auth = getAuth(app);
    this._auth = auth;
  }

  get currentUser(): User | null {
    return this._auth.currentUser;
  }

  onAuthStateChanged(callback: (user: User | null) => void) {
    return onAuthStateChanged(this._auth, callback);
  }

  async signIn() {
    const provider = new GoogleAuthProvider();
    await signInWithPopup(this._auth, provider);
  }

  async signOut() {
    await signOut(this._auth);
  }
}

export const firebaseService = new FirebaseService();
